import { trimmedOrUndefined } from "@/common/helpers/string.util";
import type { AddressValidationRequest } from "./address-validation.types";

export interface CheckoutAddress {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  citySubdivision1: string;
  country: string;
  countryCode: string;
  county: string;
  phoneNumber: string;
  postalCode: string;
}

export const toAddressValidationRequest = (address: CheckoutAddress): AddressValidationRequest => ({
  address: {
    city: trimmedOrUndefined(address.city),
    country: address.country.trim(),
    county: trimmedOrUndefined(address.county),
    line1: trimmedOrUndefined(address.addressLine1),
    line2: trimmedOrUndefined(address.addressLine2),
    line3: trimmedOrUndefined(address.addressLine3),
    phoneNumber: trimmedOrUndefined(address.phoneNumber),
    state: trimmedOrUndefined(address.citySubdivision1),
    zip: trimmedOrUndefined(address.postalCode),
  },
});
